<template>
  <Form
    ref="form"
    :model="params"
    col="6"
    :rules="rules"
    :label-width="labelWidth"
    :label-position="labelPosition"
  >
    <Row type="flex">
      <Col v-bind="grid">
        <FormItem label="活动分类" prop="category_id">
          <Select
            size="small"
            v-model="params.category_id"
            clearable
            placeholder="请选择活动分类"
          >
            <Option
              v-for="(item, index) in category"
              :value="item.id"
              :key="index"
            >
              {{ item.name }}
            </Option>
          </Select>
        </FormItem>
      </Col>
      <Col v-bind="grid">
        <FormItem label="套餐种类" prop="vip_card_cate_id">
          <Select
            size="small"
            v-model="params.vip_card_cate_id"
            clearable
            placeholder="请选择种类"
          >
            <Option
              v-for="(item, index) in categoryList"
              :value="item.id"
              :key="index"
            >
              {{ item.name }}
            </Option>
          </Select>
        </FormItem>
      </Col>
      <Col v-bind="smallGrid">
        <FormItem label="状态" prop="status">
          <Select
            size="small"
            v-model="params.status"
            clearable
            placeholder="请选择状态"
          >
            <Option value="1">正常</Option>
            <Option value="0">禁用</Option>
          </Select>
        </FormItem>
      </Col>
      <Col v-bind="smallGrid" class="ivu-text-right">
        <FormItem>
          <ButtonGroup size="small">
            <Button type="primary" @click="handleSubmit">查询</Button>
            <Button @click="handleReset">重置</Button>
          </ButtonGroup>
          <ButtonGroup size="small" class="ivu-ml-16">
            <Button type="info" @click="handleExport">导出</Button>
          </ButtonGroup>
          <!-- <a v-font="14" class="ivu-ml-8" @click="collapse = !collapse">
            <template v-if="!collapse">
              展开
              <Icon type="ios-arrow-down" />
            </template>
            <template v-else>
              收起
              <Icon type="ios-arrow-up" />
            </template>
          </a> -->
        </FormItem>
      </Col>
    </Row>
  </Form>
</template>

<script>
import { mapState } from 'vuex'
import dataFilterMixin from '@/mixins/data-filter'
import api from '@/api'
import requestSetting from '@/setting/request'

export default {
  data() {
    return {
      smallGrid: {
        xl: 4,
        lg: 4,
        md: 6,
        sm: 8,
        xs: 12,
      },
      categoryList: [],
      category: [],

      params: {
        category_id: '',
        vip_card_cate_id: '',
        status: '',
      },
      rules: {},
    }
  },
  mixins: [dataFilterMixin],
  computed: {
    ...mapState('admin/layout', ['isMobile']),
    labelWidth() {
      return this.isMobile ? undefined : 88
    },
    labelPosition() {
      return this.isMobile ? 'top' : 'right'
    },
  },
  methods: {
    //获取活动列表
    getcategory() {
      api.vipCardDetails.category({}).then((data) => {
        if (!data) return
        this.category = data.promotion_category_list || null
      })
    },
    // 取分类列表
    handleGetCategoryList() {
      api.vipCardDetails
        .categoryList({
          status: 1,
        })
        .then((data) => {
          if (!data) return
          this.categoryList = data.vip_card_category_list || []
        })
        .catch(() => {})
    },
    handleSubmit() {
      // console.log(this.params)
      this.params.page = 1
      this.$emit('on-submit', this.params)
    },
    handleReset() {
      this.$refs.form.resetFields()
      // this.$emit('on-reset')
    },
    handleExport() {
      api.vipCard
        .export({
          ...this.params,
        })
        .then((data) => {
          if (!data) return

          const url = requestSetting.baseUrl + '/download?file=' + data.file
          window.open(url)
        })
        .catch(() => {})
    },
  },
  mounted() {
    this.handleGetCategoryList()
    this.getcategory()
  },
}
</script>
